export enum PaginationValues {
    FIRSTPAGE = 'backtofirstpage',
    LASTPAGE = 'gotolastpage',
    NEXTPAGE = 'next',
    PREVIOUSPAGE = 'back'
}
